<div class="sub-cate">
  <div class="sub-cate__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>

  <ng-container>
    <div class="d-flex">
      <ng-container *ngFor="let r of regionCategoryImageList">
        <div class="card-region" [ngClass]="{ active: selectedRegionForCategoryPopup == r?.name }">
          <img loading="lazy" [src]="nonUploadBaseUrl + r.image" (click)="setCurrentRegion(r); selectedRegionForCategoryPopup = r.name" (error)="handleError($event)" />
          <div class="card-region__title">{{ r?.name | titlecase }}</div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <hr />
  <ng-container>
    <h4 class="sub-cate__title text-center" *ngIf="currentFilteredSubregions?.length">Select A Sub Region</h4>

    <section class="region-center">
      <div *ngFor="let i of currentFilteredSubregions">
        <input [id]="i?.subRegionId" type="checkbox" style="display: none" (change)="subRegionButtonClicked(i)" [(ngModel)]="i.checked" />
        <label [for]="i?.subRegionId" [ngClass]="{ active: i.checked }" class="card-sub-cate">
          <div>
            <!-- <i class="icon" [class]="icons[i.categoryName]"></i> -->
            <!-- <div class="product-count">( {{ i?.productCount || 0 }} )</div> -->
            <div class="card-sub-cate__title">
              {{ i?.name | titlecase }}
            </div>
          </div>
        </label>
      </div>
    </section>
    <hr />
    <div *ngIf="!selectOnlyOne" class="d-flex w-100 p-2 justify-content-end">
      <button class="my-button-3" (click)="closeWithResult()">Close</button>
    </div>
  </ng-container>
</div>
